<template>
	<v-list dense rounded v-if="data">
		<v-list-item>
			<v-list-item-content>
				<v-text-field
					v-model="data.title"
					:rules="[(v) => !!v || 'Title is mandatory']"
					required
					label="Title"
					prepend-icon="mdi-form-textbox"
					filled
				/>
				<i>Title cannot be changed after collection creation</i>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<script>
export default {
	name: 'FileCollectionForm',
	props: {
		data: Object,
	},
}
</script>